import { css, cx } from "styled-system/css";

type Props = {
  /** Tema del documento embebido (fondo oscuro tipo dashboard o claro tipo admin). */
  variant?: "dark" | "light";
  /** Menos bloques y altura reducida (listas editores, etc.). */
  compact?: boolean;
  /** Una sola barra centrada (pantalla de sesión o espacios chicos). */
  minimal?: boolean;
  className?: string;
  /** Altura mínima del iframe en px o string CSS. */
  minHeight?: number | string;
};

/**
 * Estado de carga visual mediante iframe con HTML estático (`/loading-embed.html`).
 * Evita repetir textos "Cargando…" y mantiene el aspecto alineado con el panel.
 */
export function LoadingFrame({
  variant = "dark",
  compact = false,
  minimal = false,
  className,
  minHeight = 320,
}: Props) {
  const params = new URLSearchParams();
  params.set("t", variant);
  if (compact) params.set("compact", "1");
  if (minimal) params.set("minimal", "1");
  const src = `/loading-embed.html?${params.toString()}`;
  const h = typeof minHeight === "number" ? `${minHeight}px` : minHeight;

  return (
    <iframe
      title="Cargando"
      aria-busy="true"
      src={src}
      scrolling="no"
      className={cx(
        css({
          border: "none",
          width: "100%",
          display: "block",
          borderRadius: "lg",
          overflow: "hidden",
          bg: "transparent",
          height: h,
          minHeight: h,
          maxHeight: h,
        }),
        className,
      )}
    />
  );
}
